import React from "react";
import Modal from "../Modal";
import styled from '@emotion/styled';
import { TabbedCard } from "../Card";
import { TabController } from "../../TabController/TabController";
import { TabPanel } from "../../TabController/TabPanel";
import TextInputWithLabel from "../../Inputs/TextInput";
import TrackingDetails from "../TrackingDetails";
import OrderSummaryTable from "../OrderSummary";
import { isMobile } from "react-device-detect";
import { Alert } from "../Alert";
import { Row } from "../../StyledComponents/Forms/Forms";

const TabContent = styled.div`
height: ${isMobile ? '500px' : '700px'};
  overflow-y: auto;
  width:100%;

  padding: 0px 40px ${isMobile ? "0px" : "30px"} 40px;

  flex-grow: 1;
  & > div { 
    margin-top: 0;
  }

padding: 20px;
padding-top: 10px;
padding-bottom: 5px;
`

const StyledModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  background: white;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 975px;
  min-height: 450px;
  overflow: hidden;
`;

const CancelButton = styled.button`
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  margin-right: 10px;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #5a6268;
  }
`;

const ModalFooter = styled.div`
  text-align: right;
  flex-shrink: 0;
  padding: 10px 0px;
`;

const Heading = styled.h3`
  margin: 0;
  margin-top: 10px;
  padding-bottom: 5px;
`;

const FieldContainer = styled.div`
  flex: 1;
  min-width: 120px;
  
  &:first-of-type {
    margin-left: 0;
  }
  
  @media (max-width: 768px) {
    flex-basis: 100%;
  }
`;

export default function Tracking({
  showHideModal,
  isModalOpen,
  colours,
  privateOrder
}) {
  const frame = privateOrder.PrivateOrderDetails.find(
    (item) => item.cProduct_Type === 'Frame'
  );
  const lens = privateOrder.PrivateOrderDetails.find(
    (item) => item.cProduct_Type === 'Rlens'
  );
  const lensCoat = privateOrder.PrivateOrderDetails.find(
    (item) => item.cProduct_Type === 'RlensCoat'
  );
  const lensTint = privateOrder.PrivateOrderDetails.find(
    (item) => item.cProduct_Type === 'RlensTint'
  );
  const lensCase = privateOrder.PrivateOrderDetails.find(
    (item) => item.cProduct_Type === 'Case'
  );

  return (
    <Modal open={isModalOpen}>
      <StyledModal>
        <TabbedCard
          label={privateOrder.PrivateOrder.customername}
          headercolour={colours.sidebar}
          headerTextColour={colours.font}
          shadow={false}
          tabController={
            <TabController colours={colours}>
              <TabPanel label="Order Summary" visible={true}>
                <TabContent>
                  <Heading>
                    Order Summary
                  </Heading>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='Customer' value={privateOrder.PrivateOrder.customername} />
                  </FieldContainer>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='Order No' value={privateOrder.PrivateOrder.orderno} />
                  </FieldContainer>

                  <Heading>
                    Eyewear Details
                  </Heading>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='Frame' value={frame?.cItem_Description} />
                  </FieldContainer>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='Lens' value={lens?.cItem_Description} />
                  </FieldContainer>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='Lens Coat' value={lensCoat?.cItem_Description} />
                  </FieldContainer>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='Lens Tint' value={lensTint?.cItem_Description} />
                  </FieldContainer>
                  <FieldContainer>
                    <TextInputWithLabel disabled={true} label='Case' value={lensCase?.cItem_Description} />
                  </FieldContainer>
                </TabContent>
              </TabPanel>
              <TabPanel label="Prescription" visible={true}>
                <TabContent>
                  <Heading>
                    Prescription
                  </Heading>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Sphere' value={privateOrder.PrivateOrder.rxlsph} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Sphere' value={privateOrder.PrivateOrder.rxrsph} />
                    </FieldContainer>
                  </Row>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Cyl' value={privateOrder.PrivateOrder.rxlcyl} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Cyl' value={privateOrder.PrivateOrder.rxrcyl} />
                    </FieldContainer>
                  </Row>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Axis' value={privateOrder.PrivateOrder.rxlaxis} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Axis' value={privateOrder.PrivateOrder.rxraxis} />
                    </FieldContainer>
                  </Row>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Add' value={privateOrder.PrivateOrder.rxladd} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Add' value={privateOrder.PrivateOrder.rxradd} />
                    </FieldContainer>
                  </Row>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Heights' value={privateOrder.PrivateOrder.rxlhgt} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Heights' value={privateOrder.PrivateOrder.rxrhgt} />
                    </FieldContainer>
                  </Row>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Prism H' value={privateOrder.PrivateOrder.rxlprismhor} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Prism H' value={privateOrder.PrivateOrder.rxrprismhor} />
                    </FieldContainer>
                  </Row>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Prism H Dir' value={privateOrder.PrivateOrder.rxlprismhordir} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Prism H Dir' value={privateOrder.PrivateOrder.rxrprismhordir} />
                    </FieldContainer>
                  </Row>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Prism V' value={privateOrder.PrivateOrder.rxlprismvert} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Prism V' value={privateOrder.PrivateOrder.rxrprismvert} />
                    </FieldContainer>
                  </Row>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Prism V Dir' value={privateOrder.PrivateOrder.rxlprismvertdir} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Prism V Dir' value={privateOrder.PrivateOrder.rxrprismvertdir} />
                    </FieldContainer>
                  </Row>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Distance OCs' value={privateOrder.PrivateOrder.rxldoc} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Distance OCs' value={privateOrder.PrivateOrder.rxrdoc} />
                    </FieldContainer>
                  </Row>
                  <Row>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Left Read OCs' value={privateOrder.PrivateOrder.rxlroc} />
                    </FieldContainer>
                    <FieldContainer>
                      <TextInputWithLabel disabled={true} label='Right Read OCs' value={privateOrder.PrivateOrder.rxrroc} />
                    </FieldContainer>
                  </Row>
                </TabContent>
              </TabPanel>
              <TabPanel label="Tracking" visible={true}>
                <TabContent>
                  <Heading>
                    Tracking History
                  </Heading>
                  {privateOrder.TrackingPointStatuses.length > 0 ?
                    (
                      <TrackingDetails
                        trackingData={privateOrder.TrackingPointStatuses} />
                    ) : (
                      <Alert type='warning'>No tracking information available.</Alert>
                    )}
                </TabContent>
              </TabPanel>
            </TabController>
          }
        >
        </TabbedCard>
        <ModalFooter>
          <CancelButton onClick={showHideModal}>Close</CancelButton>
        </ModalFooter>
      </StyledModal>
    </Modal>
  );
}
